import { render, staticRenderFns } from "./CrmUserDetails.vue?vue&type=template&id=9ceaafc6&scoped=true&"
import script from "./CrmUserDetails.vue?vue&type=script&lang=js&"
export * from "./CrmUserDetails.vue?vue&type=script&lang=js&"
import style0 from "./CrmUserDetails.vue?vue&type=style&index=0&id=9ceaafc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ceaafc6",
  null
  
)

export default component.exports